let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kSqL9")).then(() => parcelRequire('ech61'));